import network, { DEPOSIT_EVENT, REGISTER_EVENT, TAG_IFRAME } from './Manager';

const init = () => {
  network.on(
    'auth:registration',
    $this => {
      $this.Mount();
    },
    {
      domTagType: TAG_IFRAME,
      action: REGISTER_EVENT,
    },
  );

  network.on(
    'profile:depositComplete',
    ($this, { clientId, amount }) => {
      $this
        .setExtraParams({
          clientId,
          amount,
        })
        .Mount();
    },
    { action: DEPOSIT_EVENT },
  );
};

const Listen = () => {
  window.addEventListener('load', init);
};

export default Listen;
